import { useState, useEffect } from 'react';

const MIN_MARGIN_FROM_HEADER_AND_FOOTER = 30; // 15px from top and 15px from bottom
const ASPECT_RATIO_9_16 = 9 / 16;

interface UseVerticalItemSizingProps {
    isMobile: boolean;
    headerClassName?: string;
}

export const useVerticalItemSizing = (props: UseVerticalItemSizingProps) => {
    const { isMobile, headerClassName } = props;
    const [dynamicHeight, setDynamicHeight] = useState(0);
    const [topSpace, setTopSpace] = useState(0);

    const dynamicWidth = dynamicHeight * ASPECT_RATIO_9_16;

    const updateDynamicHeight = () => {
        const viewportHeight = window.innerHeight;

        const navSelector = headerClassName ? headerClassName : ".BottomHeaderArea.sticky .mainNav";
        const mainNavElement = document.querySelector(navSelector) as HTMLElement;
        const adsSargelElement = document.getElementById("ads.sargel");
        const adsBannerElement = document.getElementById("ads.banner");

        const mainNavHeight = mainNavElement ? mainNavElement.offsetHeight : 0;
        const adsSargelHeight = adsSargelElement ? adsSargelElement.offsetHeight : 0;
        const adsBannerHeight = adsBannerElement ? adsBannerElement.offsetHeight : 0;
        const bottomMargin = adsSargelHeight + adsBannerHeight + MIN_MARGIN_FROM_HEADER_AND_FOOTER;

        const height = viewportHeight - mainNavHeight - bottomMargin;
        const top = mainNavHeight + (MIN_MARGIN_FROM_HEADER_AND_FOOTER / 2);

        setDynamicHeight(height);
        setTopSpace(top);
    };

    useEffect(() => {
        updateDynamicHeight();

        const resizeObserver = new ResizeObserver(() => {
            updateDynamicHeight();
        });

        resizeObserver.observe(document.body);

        window.addEventListener("resize", updateDynamicHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateDynamicHeight);
        };
    }, []);

    const containerStyle = isMobile ? {} : { height: dynamicHeight, width: dynamicWidth, top: topSpace };

    return { dynamicHeight, dynamicWidth, topSpace, containerStyle };
};
